import { Box } from "@mui/material";
export default function PkCommonResponse(r) {
  return (
    <Box
      className="token"
      sx={{
        mt: 2,
        color: (theme) =>
          r.type == "error"
            ? theme.palette.error.light
            : theme.palette.grey[800],
      }}
    >
      <span className="token">{r.response}</span>
    </Box>
  );
}
